<script>
    // reference: [Component/MarketSwitchNotice 1]
    import {createT} from '$m7-library/utils/i18n.js';
    import {buttonStyles} from '$m7-library/main';
    import de from '$utils/lang/de.js';
    import pl from '$utils/lang/pl.js';

    const {countryMarket, ondismiss = () => {}} = $props();

    // OXID session challenge of the page (same value as the hidden stoken of every OXID form); the host element carries it.
    const stoken = document.querySelector('m7-checkout')?.dataset.stoken ?? '';

    const tde = createT({de, pl}, {lang: 'de'});
    const tpl = createT({de, pl}, {lang: 'pl'});

    // Country names per language: the server sends the name in the language of the request only, the notice shows both.
    const NAMES = {PL: {de: 'Polen', pl: 'Polska'}, DE: {de: 'Deutschland', pl: 'Niemcy'}};
    const params = (lang) => ({land: NAMES[countryMarket.code]?.[lang] ?? countryMarket.name, domain: countryMarket.domain});
    const blocks = $derived([
        {lang: 'de', t: tde, p: params('de')},
        {lang: 'pl', t: tpl, p: params('pl')},
    ]);
</script>

<div class="p-4 rounded-lg bg-white border border-grey flex flex-col gap-4" data-checkout-section="market-switch" data-market-target={countryMarket.code}>
    {#each blocks as block (block.lang)}
        <div class="flex flex-col gap-1" lang={block.lang} data-market-switch-lang={block.lang}>
            <h4 class="font-bold text-base">{block.t('Lieferung nach {land} über {domain}', block.p)}</h4>
            <p class="text-sm font-light">{block.t('Über diesen Shop liefern wir nicht nach {land}. Auf {domain} bestellst du mit dem Versand und den Preisen dieses Markts. Dein Warenkorb und dein Login kommen mit.', block.p)}</p>
        </div>
    {/each}
    <div class="flex flex-col sm:flex-row gap-3">
        <!-- Plain form, page navigation: the server issues the token and shows the intermediate page. -->
        <form method="post" action="/index.php?cl=m7handover&fnc=issue" class="sm:flex-1" data-checkout-action="market-switch">
            <input type="hidden" name="stoken" value={stoken}>
            <input type="hidden" name="ziel_markt" value={countryMarket.code}>
            <input type="hidden" name="ziel_pfad" value="/">
            <button type="submit" class={buttonStyles['elm-button']}>
                <span lang="de">{tde('Zu {domain} wechseln', {domain: countryMarket.domain})}</span><br>
                <span lang="pl" class="font-light text-sm">{tpl('Zu {domain} wechseln', {domain: countryMarket.domain})}</span>
            </button>
        </form>
        <button type="button" class="sm:flex-1 cursor-pointer font-bold p-3 text-center rounded-lg border border-grey bg-white" data-checkout-action="market-stay" onclick={ondismiss}>
            <span lang="de">{tde('Hier bleiben')}</span><br>
            <span lang="pl" class="font-light text-sm">{tpl('Hier bleiben')}</span>
        </button>
    </div>
    <p class="text-xs font-light text-gray-103">
        {tde('Wähle eine Lieferadresse in einem von uns belieferten Land oder Selbstabholung.')}<br>
        {tpl('Wähle eine Lieferadresse in einem von uns belieferten Land oder Selbstabholung.')}
    </p>
</div>
